import { setSpecificMessage, uuid } from "valibot";
setSpecificMessage(
  uuid,
  (issue) => `UUID invalide: reçu ${issue.received}`,
  "fr"
);